module.exports = __webpack_public_path__ + "img/callme.c1d3caac.jpg";